import { Component, Input } from '@angular/core';
import { CustomerModel } from 'src/app/models/customer.model';
import { PdvService } from '../../../services/pdv.service';
import { AuthService } from '../../../services/auth.service';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LocationSelectors } from 'src/app/store/location/selectors';
import { EventSelectors, PdvSelectors } from 'src/app/store/pdv/selectors';
import { StateModel } from 'src/app/models/state.model';
import { EventActions } from 'src/app/store/pdv/actions';
import { HeaderService } from 'src/app/services/header.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  public search: string = '';
  public customer?: CustomerModel;
  public logged: boolean = false;
  public loadingCompany: boolean = false;
  public companyId: string = ""
  public loggedProducer: boolean = false;
  public hasComissioner = false;
  public showBeOurPartner = environment.showBeOurPartner;
  public showLgpd = environment.showLgpd;
  public hideSearch: boolean = true
  public bgHeader
  public whiteLogo
  public whiteColor
  public showMenu: boolean = false;
  public logotag: string = ""
  @Input() showFilter: boolean = false;

  company$ = this.store.pipe(
    select(PdvSelectors.selectCompany), map(function (company) {
      return company
    }))

  logo$ = this.store.pipe(
    select(PdvSelectors.selectCompany),
    map(function (company) {
      if (document.location.host.replace('www.', '').replace("dev", "").startsWith("ingressosa.com")) {
        return "https://static-meubilhete.s3.dualstack.us-east-1.amazonaws.com/company/e383fdc4-9045-457e-af90-fc4e3b311333-company-logosite.png"
      } else {
        return company?.images?.logosite ?? ''
      }
    })
  );

  cities$ = this.store.pipe(select(LocationSelectors.selectCities));

  filteredState$ = this.store.pipe(
    select(EventSelectors.selectFilteredState),
    map((state) => state)
  );

  constructor(
    private authService: AuthService,
    private store: Store,
    private pdvService: PdvService,
    private headerService: HeaderService
  ) { }

  ngOnInit(): void {
    this.customer = this.authService.getCustomer();
    this.bgHeader = environment.bgHeader
    this.whiteLogo = environment.whiteLogo
    this.whiteColor = environment.whiteColor
    this.getCompany()

    this.headerService.getTagLogo().subscribe((res) => {
      this.logotag = res as string
    })

    this.logged = this.authService.isLoggednIn();
    this.loggedProducer = this.authService.isProducerLoggednIn();
  }

  showHideMenu() {
    if (this.showMenu) {
      this.showMenu = false
    } else {
      this.showMenu = true;
    }
  }

  getCompany() {
    this.loadingCompany = true
    this.company$.subscribe((res) => {
      this.loadingCompany = false
      if (res != null) {
        this.companyId = res!.id
      }
    })
  }

  showHideSearch() {
    if (this.hideSearch == true) {
      this.hideSearch = false
    } else {
      this.hideSearch = true
    }
  }

  /*
    pega o que foi digitado na barra de pesquisa para filtrar
  */
  public searched(): void {
    const searchedEvent = this.search;
    this.store.dispatch(EventActions.searchEvent({ searchedEvent }));
  }

  /*
    pega o estado escolhido do componente menu cities para filtrar
  */
  public selectState(filteredState: StateModel | null) {
    this.store.dispatch(EventActions.filterEventsByState({ filteredState }))
  }

  public getLogout(eve: any): void {
    if (eve == 'logout') {
      this.logged = false;
    }

  }
}
